<template>
  <div class="wrapper relative m-auto [ max-w-screen-sm min-h-screen ]">
    <main
      :class="isHomeLayout"
      class="p-4 pb-24 relative"
      :style="isGame ? 'min-height:calc(100vh - 4rem);' : 'min-height:100vh;'"
    >
      <header class="gc-header relative w-full mb-24 [ flex flex-col items-center ]">
        <h1 :class="isHomeHeading" class="relative [ font-bold ]">
          <a v-if="!isHome" href="/">
            groomin
          </a>
          <template v-else>
            groomin
          </template>
        </h1>
        <h3 v-if="isHome" class="[ relative top-[-10px] ] font-medium">
          a simple scrum poker tool
        </h3>
      </header>
      <slot></slot>
      <footer class="[ w-full h-24 ] [ absolute bottom-0 left-0 ] [ flex flex-col items-center justify-center ]" :class="{ '-bottom-16' : isGame }">
        <small class="text-gray-500 text-xs">built by</small>
        <div class="flex justify-center items-center" style="cursor:help">
          <small class="transition-all [ text-sm text-center font-medium ]">
            wecanhaxweekend
          </small>
          <small class="transition-all absolute [ text-xs text-center font-medium ]">
            khamil aryansyah & yahya sahaja
          </small>
        </div>
      </footer>
    </main>
  </div>
</template>

<script>

export default {
  name: 'BasicLayout',
  computed: {
    isGame() {
      return this.$route.name === 'Game'
    },
    isPreGame() {
      return this.$route.name === 'PreGame'
    },
    isHome() {
      return !this.isPreGame && !this.isGame
    },
    isHomeHeading() {
      return this.isHome ? 'huefied text-6xl sm:text-7xl' : 'text-5xl'
    },
    isHomeLayout() {
      return { '[ flex flex-col justify-center ]' : this.isHome }
    },
  },
}
</script>

<style lang="scss" scoped>
  .huefied {
    line-height: 1.25;
      background-image: linear-gradient(to right, #ec407a, #fdd835);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-animation: hue 5s infinite linear;
  }
  @-webkit-keyframes hue {
    from {
      -webkit-filter: hue-rotate(0deg);
    }
    to {
      -webkit-filter: hue-rotate(-360deg);
    }
  }
  footer {
    > div {
      &:hover small:first-child {
        visibility: hidden;
        opacity: 0;
      }
      &:hover small:last-child {
        visibility: visible;
        opacity: 1;
      }
      small:last-child {
        visibility: hidden;
        opacity: 0;
      }
    }
  }
</style>
